<div class="wrapper-md">
    <app-breadcrumbs [items]="[
                     { url: '/employee-applications', text: 'employeeApplications_title' },
					 { text: 'myEmployeeApplications_title' }
					 ]"></app-breadcrumbs>

    <header class="content-header">
        <h1 [translate]="'myEmployeeApplications_title'"></h1>
    </header>

    <form #form="ngForm" *ngIf="structures.length">
            <div class="form-field">
                <app-select [options]="structures"
                            [placeholder]="'myEmployeeApplications_lblStructure' | translate"
                            [displayProperty]="'Name'"
                            [valueProperty]="'Id'"
                            [(ngModel)]="filters.structureId"
                            [multiple]="true"
                            [filter]="structureFilterFn"
                            name="filterStructureId"
                            (selectionChange)="filter()">
                </app-select>
            </div>

            <div class="row">
                <div class="col-sm form-field">
                    <app-date name="filterFrom"
                              [(ngModel)]="filters.from"
                              [placeholder]="'myEmployeeApplications_lblFrom' | translate"
                              [max]="filters.to"
                              (dateChange)="filter()"></app-date>
                </div>

                <div class="col-sm form-field">
                    <app-date name="filterTo"
                              [(ngModel)]="filters.to"
                              [placeholder]="'myEmployeeApplications_lblTo' | translate"
                              [min]="filters.from"
                              (dateChange)="filter()"></app-date>
                </div>

                <div class="col-md form-field">
                    <input class="form-control"
                           name="filterSearch"
                           [placeholder]="'myEmployeeApplications_lblSearch' | translate"
                           [(ngModel)]="filters.search"
                           (input)="filter()">
                </div>
            </div>
    </form>

    <app-table [rows]="items"
               [columns]="columns"
               [page]="page"
               [pageSize]="pageSize"
               [total]="total"
               [auto]="false"
               (pageChange)="onPage($event)"
               (sortChange)="onSort($event)">
        <ng-template #rowTemplate let-row>
            <tr>
                <td>
                    <div>{{getTypeDisplayName(row.Type)}}</div>
                    <div class="hidden-md-up mt-1">
                        <div class="text-sub">{{'myEmployeeApplications_lblEmployee' | translate}}</div>
                        <div>{{row.FirstName}} {{row.LastName}} ({{row.Upn}})</div>
                    </div>
                    <div class="hidden-lg-up mt-1">
                        <div class="text-sub">{{'myEmployeeApplications_lblStructure' | translate}}</div>
                        <div>{{row.Structure}} ({{row.Workload}})</div>
                    </div>
                    <div class="hidden-lg-up mt-1">
                        <div class="text-sub">{{'myEmployeeApplications_lblSubmitted' | translate}}</div>
                        <div>{{row.Created | appDate}}</div>
                    </div>
                    <div class="hidden-lg-up mt-1" *ngIf="row.Registered">
                        <div class="text-sub">{{'myEmployeeApplications_lblRegistered' | translate}}</div>
                        <div>{{row.Registered | appDate}}</div>
                    </div>
                    <div class="hidden-md-up mt-1" *ngIf="row.Status">
                        <div class="text-sub">{{'myEmployeeApplications_lblSigned' | translate}}</div>
                        <div>
                            <app-employee-application-status [value]="row.Status"></app-employee-application-status>
                        </div>
                    </div>
                </td>
                <td class="hidden-sm-down">
                    <div>{{row.FirstName}} {{row.LastName}}</div>
                    <div class="text-sub">{{row.Upn}}</div>
                </td>
                <td class="hidden-md-down">
                    <div>{{row.Structure}}</div>
                    <div class="text-sub">{{row.Workload}}</div>
                </td>
                <td class="hidden-md-down">{{row.Created | appDate}}</td>
                <td class="hidden-md-down">{{row.Registered | appDate}}</td>
                <td class="hidden-sm-down">
                    <app-employee-application-status [value]="row.Status" *ngIf="row.Status"></app-employee-application-status>
                </td>
                <!-- no file available at this time -->
                <!--<td>
                    <div class="table-actions">
                        <button type="button"
                                class="btn btn-outline btn-icon"
                                (click)="download(row)"
                                [ngbTooltip]="'download' | translate">
                            <i class="fi fi-rs-download"></i>
                        </button>
                    </div>
                </td>-->
            </tr>
        </ng-template>
    </app-table>
</div>
